module.exports = require("dayspan");


//////////////////
// WEBPACK FOOTER
// external "dayspan"
// module id = 0
// module chunks = 0